import moment from 'moment';
import axios from 'axios';
import * as types from '@/store/mutationTypes';
import HOST from '@/store/host';
import { showNotification } from '@/helpers/helpers';

const state = {
  blogList: [],
  currentBlog: null,
  relatedPosts: [],
  page: 1,
  totalRecords: 0,
  itemsPerPage: 0,
};

const actions = {
  getBlogTotalRecords({ commit }) {
    return axios
      .get(`${HOST}/blog/page-count/`)
      .then(({ data }) => commit(types.GET_BLOG_LIST_TOTAL_RECORDS, data.count))
      .catch(() => Promise.reject());
  },
  getBlogList({ commit }, { page, itemsPerPage }) {
    return axios
      .get(`${HOST}/blog/`, {
        params: {
          ...page && { page },
          ...itemsPerPage && { items_per_page: itemsPerPage },
        },
      })
      .then(({ data }) => commit(types.GET_BLOG_LIST, { data, page }))
      .catch(() => Promise.reject());
  },
  getBlogById({ commit }, { id, notificationParams }) {
    return axios
      .get(`${HOST}/blog/${id}/`)
      .then(({ data }) => commit(types.GET_BLOG_BY_ID, data))
      .catch((error) => {
        showNotification({
          ctx: notificationParams.ctx,
          variant: 'danger',
          title: 'Error',
          message: error?.response?.data?.detail || 'An error occurred',
        });
      });
  },
  getRelatedPosts({ commit }, id) {
    return axios
      .get(`${HOST}/blog/related-posts/`, {
        params: {
          ...id && { id },
        },
      })
      .then(({ data }) => commit(types.GET_RELATED_POSTS, data))
      .catch(() => Promise.reject());
  },
  clearBlogData({ commit }) {
    commit(types.CLEAR_BLOG_DATA);
  },
};

const mutations = {
  [types.GET_BLOG_LIST_TOTAL_RECORDS](state, count) {
    state.totalRecords = count;
  },
  [types.GET_BLOG_BY_ID](state, blog) {
    state.currentBlog = { ...blog, createdBy: blog.created_by };
  },
  [types.GET_RELATED_POSTS](state, posts) {
    state.relatedPosts = posts;
  },
  [types.GET_BLOG_LIST](state, { data, page }) {
    state.page = page;
    state.blogList = data.map((b) => ({
      ...b,
      createdBy: b.created_by,
      date: moment(b.date).format('ddd, MMM DD, YYYY'),
    }));
  },
  [types.CLEAR_BLOG_DATA](state) {
    state.blogList = [];
    state.page = 1;
    state.itemsPerPage = 0;
    state.totalRecords = 0;
  },
};

export default {
  state,
  actions,
  mutations,
};
